import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import config from 'devextreme/core/config'
import { loadMessages, locale } from 'devextreme/localization'
import elMessages from 'devextreme/localization/messages/el.json'
import { licenseKey } from '../../devextreme-license'
import overrideElMessages from '../assets/override-el-messages.json'
import { AuthenticationService } from './core/authentication/authentication.service'
import { CasesService } from './core/services/cases.service'
import { FoldersService } from './core/services/folders.service'
import { ThemesService } from './core/services/theme.service'

config({ licenseKey })

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'BizSmart Eurobank'

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private themeService: ThemesService,
    private casesService: CasesService,
    private foldersService: FoldersService
  ) {
    loadMessages(elMessages)
    loadMessages(overrideElMessages)
    locale('el')
  }

  ngOnInit() {
    // localStorage
    const version = +JSON.parse(localStorage.getItem('version'))
    if (!version || version < 1) {
      localStorage.setItem('version', '1')
      this.casesService.init()
      this.foldersService.init()
    }
    if (!this.authenticationService.isAuthenticated()) {
      this.router.navigate(['login'])
    } else {
      this.authenticationService.checkExpired()
    }
  }
}
